import { defineEntityContract } from 'shared/channels/entity';
import { DomainMessagesTypes } from 'shared/domain/messages/message';
import type { ProcessType } from './types/model';
import type { UpdateProcessWorkflowRequest } from './types/requests';

export type ProcessEvents = {
  [DomainMessagesTypes.allProcesses]: { hasAll?: boolean; items: ProcessType[] };
  [DomainMessagesTypes.updatedProcess]: ProcessType;
  [DomainMessagesTypes.processError]: unknown;
  [DomainMessagesTypes.pullFailed]: undefined;
};

/** A workflow change resolves once queued; its outcome follows as an event with its `uniqueId`. */
export type ProcessRequests = {
  updateWorkflow: { request: UpdateProcessWorkflowRequest; response: void };
};

export const processContract = defineEntityContract<ProcessType, ProcessEvents, ProcessRequests>(
  'processChannel',
  { collectionEvent: DomainMessagesTypes.allProcesses }
);
